import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { CloudUpload } from '@mui/icons-material';
import { Prompt } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ViewList from '@mui/icons-material/ViewList';
import { Card, IconButton } from '@totalsoft/rocket-ui';
import { isValid } from '@totalsoft/pure-validations-react';
import DocumentTemplateGeneralDataComponent from './DocumentTemplateGeneralDataComponent';

export const DocumentTemplateGeneralDataCard = ({
  documentTemplate,
  outputTypes,
  contentTypes,
  targetAreas,
  documentTypes,
  exportTypes,
  onPropertyChanged,
  onSave,
  onDownloadFile,
  onFileSelected,
  onLocalDiskFileNameChanged,
  visibleUniqueByDocument,
  computing,
  isFileUploaded,
  validation
}) => {
  const [t] = useTranslation();
  const fileInputRef = React.createRef();

  const handleUploadClick = () => {
    fileInputRef.current.value = '';
    fileInputRef.current.click();
  };

  return (
    <Card
      icon={ViewList}
      iconColor='primary'
      title={t('DocumentTemplate.GeneralData')}
      actions={
        <>
          <input type='file' style={{ display: 'none' }} ref={fileInputRef} onChange={onFileSelected} />
          <Tooltip title={t('Tooltips.Upload')}>
            <IconButton id={`documentTemplate_Upload`} color='transparent' disabled={computing} onClick={handleUploadClick}>
              <CloudUpload fontSize='medium' />
            </IconButton>
          </Tooltip>
          <IconButton
            id={`documentTemplate_Download`}
            color='transparent'
            fontSize='medium'
            type='download'
            tooltip={t('Tooltips.Download')}
            disabled={computing || !isFileUploaded}
            onClick={() => onDownloadFile(documentTemplate?.localDiskFileName)}
          />
          <IconButton
            color='transparent'
            type='save'
            fontSize='medium'
            onClick={onSave}
            tooltip={t('Tooltips.DocumentTemplate.SaveChanges')}
            disabled={!documentTemplate.changed || !(validation |> isValid)}
          />
        </>
      }
    >
      <>
        <Prompt when={documentTemplate.changed} message={t('DocumentTemplate.LeavingWithoutSavingDocumentTemplate')} />
        <DocumentTemplateGeneralDataComponent
          documentTemplate={documentTemplate}
          outputTypes={outputTypes}
          contentTypes={contentTypes}
          targetAreas={targetAreas}
          documentTypes={documentTypes}
          exportTypes={exportTypes}
          onPropertyChanged={onPropertyChanged}
          onLocalDiskFileNameChanged={onLocalDiskFileNameChanged}
          visibleUniqueByDocument={visibleUniqueByDocument}
          validation={validation}
        />
      </>
    </Card>
  );
};

DocumentTemplateGeneralDataCard.propTypes = {
  documentTemplate: PropTypes.object.isRequired,
  outputTypes: PropTypes.array.isRequired,
  contentTypes: PropTypes.array.isRequired,
  targetAreas: PropTypes.array.isRequired,
  documentTypes: PropTypes.array.isRequired,
  exportTypes: PropTypes.array.isRequired,
  onPropertyChanged: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onDownloadFile: PropTypes.func.isRequired,
  onFileSelected: PropTypes.func.isRequired,
  onLocalDiskFileNameChanged: PropTypes.func.isRequired,
  visibleUniqueByDocument: PropTypes.bool.isRequired,
  computing: PropTypes.bool.isRequired,
  isFileUploaded: PropTypes.bool,
  validation: PropTypes.object.isRequired
};

export default DocumentTemplateGeneralDataCard;
